import React from 'react';

import Badge from 'CommonComponents/Badge';
import ToggleFormField from 'CommonComponents/ToggleFormField';

/**
 * The surfaces the time keeping switch controls. They are documentation only —
 * each arrives with its own ticket. `available` marks the ones that have
 * shipped: flip it when a surface lands, or this card tells an admin a screen
 * is unavailable while its menu item sits beside it.
 */
const TIME_KEEPING_SURFACES = [
    {
        audience: 'All users',
        variant: 'info',
        description: 'My Time Record appears in the main menu',
        available: true,
    },
    {
        audience: 'Organisation Admin',
        variant: 'success',
        description: 'Rate Card appears in the main menu',
        available: true,
    },
    {
        audience: 'Event Admin',
        variant: 'neutral',
        description: 'Time category appears in Report Centre (Project time report · Projects overview with time)',
        available: false,
    },
];

export default function ModulesCard({ disabled }) {
    return (
        <div className="table__card">
            <div className="tw-flex tw-flex-col tw-gap-1 tw-mb-6">
                <h2 className="tw-text-blue tw-text-xl tw-font-semibold tw-mb-0">{$t('Modules')}</h2>
                <p className="tw-text-sm tw-font-medium tw-text-charcoal-50 tw-mb-0">{$t('optional functionality, controlled per organisation')}</p>
            </div>

            <div className="tw-flex tw-flex-col tw-gap-3">
                <ToggleFormField
                    type="checkbox"
                    name="time_keeping_enabled"
                    id="time_keeping_enabled"
                    disabled={disabled}
                    label={<span className="tw-text-sm tw-font-semibold">{$t('Time keeping')}</span>}
                />

                <div className="tw-flex tw-flex-col tw-gap-3 tw-ms-12">
                    <p className="tw-text-sm tw-text-charcoal-75 tw-mb-0">
                        {$t(
                            'Record time against events using the organisation rate card, and report billed time value, time cost and time margin. Time is a recharge record — it never posts to actuals, commitments or cashflow.',
                        )}
                    </p>

                    <div className="tw-flex tw-flex-col tw-gap-2">
                        {TIME_KEEPING_SURFACES.map((surface) => (
                            <div key={surface.audience} className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-start tw-gap-1 sm:tw-gap-3">
                                <span className="sm:tw-w-44 tw-shrink-0">
                                    <Badge variant={surface.variant} size="md" className="tw-w-full tw-justify-center">
                                        {$t(surface.audience)}
                                    </Badge>
                                </span>
                                <span className="tw-text-sm tw-text-charcoal-75">
                                    {$t(surface.description)}{' '}
                                    {!surface.available && <span className="tw-text-charcoal-50 tw-italic">({$t('not yet available')})</span>}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
